export enum ColorDTO {
  AAA_10gray = 'AAA_10gray',
  BBB_11gray = 'BBB_11gray',
  CCC_12gray = 'CCC_12gray',
  DDD_13gray = 'DDD_13gray',
  EEE_14gray = 'EEE_14gray',
  FFF_White = 'FFF_White',
  _000_Black = '_000_Black',
  _111_1gray = '_111_1gray',
  _222_2gray = '_222_2gray',
  _333_3gray = '_333_3gray',
  _444_4gray = '_444_4gray',
  _555_5gray = '_555_5gray',
  _666_6gray = '_666_6gray',
  _777_7gray = '_777_7gray',
  _888_8gray = '_888_8gray',
  _999_9gray = '_999_9gray',
}

export const colorDtoToHex = (color: ColorDTO): string =>
  `#${color.replace(/^_/, '').slice(0, 3)}`;

export const colorDtoToLabel = (color: ColorDTO): string =>
  color.replace(/^_/, '').slice(4);
